import axios from 'axios';
import type { SystemErrorMessageKey } from '../models/validation-message.model';

/**
 * Classifies an unknown catch-block error into the appropriate system error message key.
 * Returns networkError for true network failures (no HTTP response), unexpectedError otherwise.
 */
export function resolveSystemErrorKey(error: unknown): SystemErrorMessageKey {
  if (axios.isAxiosError(error) && !error.response) {
    return 'createShipment.system.networkError';
  }

  return 'createShipment.system.unexpectedError';
}
